import { UPDATE_BUSINESS_CHATROOM_ID } from '../actions';

export const businessChatRoomId = (state = '', action) => {
  switch (action.type) {
    case UPDATE_BUSINESS_CHATROOM_ID: {
      return action.chatRoomId;
    }
    default:
      return state;
  }
};
